import script from "./BlogSocial.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogSocial.vue?vue&type=script&lang=ts&setup=true"

import "./BlogSocial.vue?vue&type=style&index=0&id=313632b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313632b2"]])

export default __exports__